export default __webpack_public_path__ + "static/media/ui-ux.0366b465.png";